import React from 'react'
import Header from '../../../Layout/Header'
import Section1 from '../Section1'
import UserSection3 from '../Userssections'
import Section2 from '../Section2'

export default function UserDna() {
    return (
        <div className='bg-cover text-white' style={{ backgroundImage: 'url("/assets/bg/Fundbg.svg")' }}>
            <div className='flex flex-col min-h-screen'>
                <div><Header /></div>
                <Section1 />
            </div>
            <Section2 />
            <UserSection3 />
        </div>
    )
}
